import { addDomainOnUrl } from '../../Utils/functionnals'
import {
  SubscriptionRank,
  SubscriptionType,
} from '../../types/firm/Subscription'
import { FirmTeaserProps } from '../firms'
import { formatNbOffices } from '../firms/format'
import type { AlgoliaSearchResult } from './resultMapper'

export type FirmAlgoliaSearchResult = {
  name: string
  slug: string
  city: string
  firmId: number
  postalCode?: string
  totalEmployees: string
  header?: {
    url?: string
    formats?: {
      small?: string
      medium?: string
      thumbnail?: string
      large?: string
    }
  } | null
  logo: {
    url?: string
    formats?: {
      thumbnail?: string
    }
  } | null
  nbTotalOffers: number
  nbOffices: number
  subscriptionType: SubscriptionType
  subscriptionRank: SubscriptionRank
  likesCount: number
}

/**
 * Formats city and postal code for display
 * @param city - The city name
 * @param postalCode - Optional postal code
 * @returns Formatted city string with truncated postal code
 */
export const formatCityDisplay = (city: string, postalCode?: string): string => {
  const cityCut = city.length > 18 ? `${city.slice(0, 17)}...` : city
  const postalCodeSuffix = postalCode ? `(${postalCode.slice(0, 2)})` : ''
  if (postalCodeSuffix && postalCodeSuffix !== '(nu)')
    return `${cityCut} ${postalCodeSuffix}`.trim()

  return city?.trim()
}

export const FirmTeaserMapper = (
  searchResult: AlgoliaSearchResult<FirmAlgoliaSearchResult>,
): FirmTeaserProps => {
  const city = searchResult?.hit?.city ?? ''
  const nbOfficesToDisplay = formatNbOffices(searchResult.hit.nbOffices)
  const firmLogo = addDomainOnUrl(searchResult.hit.logo?.url) ?? null
  const firmHeader =
    addDomainOnUrl(searchResult.hit.header?.formats?.small) ?? null

  return {
    id: searchResult.hit.firmId,
    name: searchResult.hit.name,
    city: formatCityDisplay(city, searchResult.hit.postalCode),
    header: firmHeader,
    logo: firmLogo,
    totalEmployees: searchResult.hit.totalEmployees,
    url: `/cabinets/${searchResult.hit.slug}`,
    nbTotalOffers: searchResult.hit.nbTotalOffers,
    nbOffices: nbOfficesToDisplay,
    subscriptionType: searchResult.hit.subscriptionType,
    likesCount: searchResult.hit.likesCount ?? undefined,
  }
}
